module.exports = __webpack_public_path__ + "static/img/dnn_logo.fbf18e8d.png";